
import * as React from "react";


export interface AttributePanelProps {
    attributes:{[key: string]:string};
    header: string;
    hideTableHeader? : boolean;
}

export class AttributePanel extends React.Component<AttributePanelProps, {}>{

    getOrderedAttributes() {
        let orderAttributes:{[key: string]:string} = {};
        if(this.props.attributes) {
            Object.keys(this.props.attributes)
                .sort()
                .forEach((v,i) => {
                    orderAttributes[v] = this.props.attributes[v];
                });
        }
        return orderAttributes;
    }

    renderTH() {
        if (this.props.hideTableHeader === true) {
            return (<thead></thead>);
        }

        return (
            <thead>
                <tr>
                    <th>Key</th>
                    <th>Value</th>
                </tr>
            </thead>
        )
    }

    render() {
        return(
            <div className={"card-box"}>
                <h4>{this.props.header}</h4>

                <table className="table table-striped">
                    {this.renderTH()}
                    <tbody>
                    {this.getAttributes()}
                    </tbody>
                </table>
            </div>
        );
    }

    getAttributes() {
        let attr = [];
        let orderedAttributes:{[key: string]:string | any } = this.getOrderedAttributes();
        for (let x in orderedAttributes) {
            attr.push(this.renderAttribute(x, orderedAttributes[x]));
        }
        return attr;
    }

    renderAttribute(key:string, value:string | any) {
        return (
            <tr key={key}>
                <td>{key}</td>
                {typeof value === "string" && value.startsWith("http") ? <td><a rel="noreferrer" href={value} target={"_blank"}>{value}</a></td> : <td>{value}</td>}
            </tr>
        );
    }

}
